import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, Clock, ShieldCheck, MessageSquare, Lock } from "lucide-react";
import { Button } from "../../components/ui/button";
import EgHeaderNav from "../../components/EgHeaderNav";
import Logo from "../../components/Logo";
import { trackVisit } from "../../lib/api";

const SUPPORT_EMAIL = "support@bluebook.cx";

export default function EgContact() {
  useEffect(() => {
    trackVisit("eg-contact");
    try { sessionStorage.setItem("bb_funnel", "eg"); } catch (_) { /* ignore */ }
  }, []);

  return (
    <div className="min-h-screen bg-[#040914] text-white" dir="rtl" data-testid="eg-contact-root">
      <EgHeaderNav variant="static" />

      <section className="py-14 sm:py-24">
        <div className="max-w-2xl mx-auto px-5 sm:px-6">
          <div className="text-[#C5A059] text-[10px] sm:text-xs tracking-[0.3em] mb-3 text-center">للتواصل</div>
          <h1 className="font-display text-3xl sm:text-5xl font-black text-center leading-tight">
            تواصل <span className="text-[#C5A059]">معنا</span>
          </h1>
          <p className="mt-5 text-sm sm:text-lg text-[#A1B0C6] leading-relaxed text-center">
            عندك سؤال، اقتراح، أو محتاج مساعدة بخصوص الكتاب أو الطلب؟ فريق الدعم هنا عشانك.
          </p>

          <div className="mt-9 sm:mt-12 bg-gradient-to-br from-[#C5A059]/15 via-[#C5A059]/8 to-transparent border border-[#C5A059]/40 rounded-sm p-6 sm:p-9 text-center shadow-[0_0_40px_rgba(197,160,89,0.15)]" data-testid="contact-card">
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#C5A059]/15 border border-[#C5A059]/50 flex items-center justify-center">
                <Mail className="w-7 h-7 sm:w-8 sm:h-8 text-[#C5A059]" strokeWidth={1.8} />
              </div>
            </div>
            <div className="text-[10px] sm:text-xs tracking-[0.3em] text-[#C5A059] font-bold mb-2">البريد الإلكتروني</div>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="block text-white text-lg sm:text-2xl font-black underline underline-offset-4 decoration-[#C5A059]/50 hover:decoration-[#C5A059] transition"
              data-testid="contact-email-link"
              style={{ direction: "ltr" }}
            >
              {SUPPORT_EMAIL}
            </a>
            <p className="mt-4 text-xs sm:text-sm text-[#A1B0C6] leading-relaxed">
              ابعت رسالتك، وهنرد عليك خلال 24 ساعة عمل.
            </p>
          </div>

          <div className="mt-7 sm:mt-9 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4" data-testid="contact-promises">
            <div className="bg-[#0B1D3A]/60 border border-[#C5A059]/15 rounded-sm p-4 text-center">
              <Clock className="w-5 h-5 text-[#C5A059] mx-auto mb-2" />
              <div className="text-xs sm:text-sm text-white/90 font-bold">رد خلال 24 ساعة</div>
            </div>
            <div className="bg-[#0B1D3A]/60 border border-[#C5A059]/15 rounded-sm p-4 text-center">
              <MessageSquare className="w-5 h-5 text-[#C5A059] mx-auto mb-2" />
              <div className="text-xs sm:text-sm text-white/90 font-bold">دعم بشري حقيقي</div>
            </div>
            <div className="bg-[#0B1D3A]/60 border border-[#C5A059]/15 rounded-sm p-4 text-center">
              <ShieldCheck className="w-5 h-5 text-[#C5A059] mx-auto mb-2" />
              <div className="text-xs sm:text-sm text-white/90 font-bold">خصوصية مضمونة</div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link to="/eg" data-testid="contact-back-to-home">
              <Button className="bg-transparent border-2 border-[#C5A059] text-[#C5A059] hover:bg-[#C5A059] hover:text-[#040914] font-bold rounded-sm px-6 py-5">
                العودة للصفحة الرئيسية
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <footer className="border-t border-[#C5A059]/15 py-8">
        <div className="max-w-5xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#A1B0C6]">
          <Logo className="h-9 w-9" />
          <div>© {new Date().getFullYear()} الكتاب الأزرق</div>
          <div className="flex items-center gap-2"><Lock className="w-3.5 h-3.5 text-[#C5A059]" /> دفع آمن</div>
        </div>
      </footer>
    </div>
  );
}
